'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z' });

var TextFormat = function TextFormat(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

TextFormat = (0, _pure2.default)(TextFormat);
TextFormat.muiName = 'SvgIcon';

exports.default = TextFormat;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/TextFormat.js
// module id = 2930
// module chunks = 0